/// <reference types="./SessionUtils.d.ts" />
import { assertIsDefined } from './AssertUtils.js';
const sessionWeakMap = new WeakMap();
export function createSession({ session, subjectInternalId, }) {
    const frozenSession = Object.freeze({ ...session });
    sessionWeakMap.set(frozenSession, subjectInternalId);
    return frozenSession;
}
export function getSessionSubjectInternalId(session) {
    const subjectInternalId = sessionWeakMap.get(session);
    assertIsDefined(subjectInternalId);
    return subjectInternalId;
}
//# sourceMappingURL=SessionUtils.js.map